<template>
  <v-card>
    <v-card-title></v-card-title>

    <v-card-text style="max-height: 500px; overflow-y: auto">
      <SelectableIngredientGroupList
        :selectedIngredients="selectedIngredients"
        @select="select"
      />
    </v-card-text>

    <v-card-actions> </v-card-actions>
  </v-card>
</template>

<script>
  import SelectableIngredientGroupList from './SelectableIngredientGroupList.vue'

  export default {
    name: 'IngredientsSelectionDialog',
    components: { SelectableIngredientGroupList },
    props: {
      selectedIngredients: []
    },
    methods: {
      select(value) {
        this.$emit('select', value)
      }
    }
    // computed: {
    //   groups() {
    //     const excludedProductsIdSet = new Set(this.selectedProducts)
    //     return this.$productGroup.list
    //       .filter(e => e.id !== this.$productGroup.item.id)
    //       .map(group => ({
    //         ...group,
    //         products: group.products.filter(p => !excludedProductsIdSet.has(p.id))
    //       }))
    //       .filter(group => group.products.length > 0)
    //   }
    // },
  }
</script>
